import Vue from 'vue';
import Vuex from 'vuex';

import filterData from './modules/filterData';
import profileConfig from './modules/profileConfig';
import mapTemplate from './modules/mapTemplate';
import geographyTemplate from './modules/geographyTemplate';
import facilityTemplate from './modules/facilityTemplate';
import tableData from './modules/tableData';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentView: 'MapView',
    drawer: true,
    errors: [],
    messages: []
  },
  mutations: {
    setCurrentView(state, currentView) {
      console.log('setting');
      state.currentView = currentView;
    },
    toggleDrawer(state, toggle) {
      if (toggle === undefined || typeof toggle !== "boolean") {
        console.log('setting toggling drawer');
        state.drawer = !state.drawer;
      } else {
        console.log('toggling drawer', toggle);
        state.drawer = toggle;
      }
    },
    showList(state) {
      state.drawer = false;
      state.currentView = 'ListView';
    },
    setError(state, value) {
      state.errors.push(value);
    },
    setMessage(state, value) {
      state.messages.push(value);
    },
    clearErrors(state) {
      state.errors = [];
    },
    clearMessages(state) {
      state.messages = [];
    }
  },
  getters: {
    currentView: (state) => {
      return state.currentView;
    },
    errors: (state) => {
      return state.errors;
    },
    messages: (state) => {
      return state.messages;
    },
    getDrawer: (state) => {
      return state.drawer;
    }
  },
  modules: {
    filterData,
    profileConfig,
    mapTemplate,
    geographyTemplate,
    facilityTemplate,
    tableData
  }
});
